// extracted by mini-css-extract-plugin
export default {"marketName":"styles_marketName__K4DE4","runnersColumns":"styles_runnersColumns__bDANq","runnersColumns__full":"styles_runnersColumns__full__6vsLO"};